<template lang="html">
  <div class="detailsCtr">
    <ConfirmModal :dialogVisible='showConfirmDialog' @close="showConfirmDialog = false" @confirmed="emitDelte($event)" message="Are you sure ? This action can't be canceled." ></ConfirmModal>


    <div class="detailsHead">
      <div class="leftPart">
        <v-img :src="require('@/assets/infoCriteria.svg')" alt=""></v-img>
        {{ $t("Info")}}
      </div>

      <div class="rightPart" v-if="(!criteria.isGlobal || forceedit) && !forcenoedit ">
        <img :src="require('@/assets/editCriteria.svg')" @click="pleaseEdit(criteria)" alt="" v-if="!hideEdit"/>
        <img :src="require('@/assets/trashInnoBlack.svg')" @click="pleaseRemove(criteria)" alt="" v-if="!hideEdit"/>

      </div>

    </div>

    <div class="detailsContent">
      <div class="oneDetailCtr" v-if="!hideGroup">
        <span class="detailName">{{ $t("Group: ")}}&nbsp;</span>
        <span class="detailValue" v-if="Array.isArray(criteria.group)">
          <span v-for="(group,g) in criteria.group" :key="g">
          {{getGroupNameById(group)}}<span v-if="g < criteria.group.length - 1">, </span>
          </span>
        </span>
        <span class="detailValue" v-else>{{getGroupNameById(criteria.group)}}</span>
      </div>
      <div class="oneDetail">
        <span class="detailName">{{ $t("Name: ")}}&nbsp;</span>
        <span class="detailValue">{{criteria.name}}</span>
      </div>
      <div class="oneDetail" v-if="criteria.description">
        <span class="detailName">{{ $t("Definition: ")}}&nbsp;</span>
        <span class="detailValue">{{criteria.description}}</span>
      </div>
      <div class="oneDetail">
        <span class="detailName">{{ $t("Rating values: ")}}&nbsp;</span>
        <span class="detailValue">
          <span v-if="criteria.rating_1"><br/>1 - {{criteria.rating_1}}</span>
          <span v-else><br/>1 - Very low</span>
          <span v-if="criteria.rating_2"><br/>2 - {{criteria.rating_2}}</span>
            <span v-else><br/>2 - Low</span>
          <span v-if="criteria.rating_3"><br/>3 - {{criteria.rating_3}}</span>
            <span v-else><br/>3 - Medium</span>
          <span v-if="criteria.rating_4"><br/>4 - {{criteria.rating_4}}</span>
            <span v-else><br/>4 - High</span>
          <span v-if="criteria.rating_5"><br/>5 - {{criteria.rating_5}}</span>
            <span v-else><br/>5 - Very high</span>
        </span>
      </div>

    </div>
  </div>

</template>


<script>
import ConfirmModal from '@/components/modals/ConfirmModal.vue'


export default {
  name : "CriteriaDetails",
  components:{
    ConfirmModal
  },
  data() {
    return {

      showConfirmDialog: false,
      asked_for_delete: null,
    }
  },
  methods:{
    getGroupNameById(id) {
      console.log("search id:",id);
      console.log(this.criteriaGroups);
      var group = this.criteriaGroups.find(g => g._id.$oid == id.$oid);
      console.log("dinf ",group);
      return group ? group.name : null; // Return the groupname or null if not found
    },
    pleaseEdit(criteria){
      this.$emit('pleaseEdit',criteria);
    },
    emitDelte(v){
      if(v){
        this.$emit('pleaseDeleted',this.asked_for_delete);

      }
    },
    pleaseRemove(criteria){
      this.showConfirmDialog = true;
      this.asked_for_delete = criteria;

    }
  },
  props: ["criteria","criteriaGroups","hideEdit","hideGroup","forceedit","forcenoedit"]
}
</script>

<style media="screen" scoped>

.detailsCtr{
  position: absolute;
  background: #FFF;
max-width: 100vw;  /* Restricts width to viewport width */
  overflow: auto;
  color: #000;
  bottom: 0;
  left: 0;
  z-index:99;
  transform: translateY(calc(100% + 10px));
  min-width:300px;
  box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.12);
  font-size: 12px;
  line-height: 15px;
  display: flex;
  align-items: center;
  text-transform: none !important;
  color: #3783c5;
  flex-direction: column;

}
.detailsHead {
  display: flex;
  align-content: space-between;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-bottom: 1px solid #000;
  width:100%;
  text-transform:uppercase;
}
.detailsHead .leftPart{
  display: flex;
  gap: 10px;
}
.detailsCtr .detailsContent{
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap:5px;
  font-size:14px;
  line-height: 20px;
  width: 100%;
}
.detailName{
  font-weight: 700;
  color:rgb(5,35,101);
}
.detailValue{
  font-weight: 400;
  color:rgb(58,130,196);
}
.rightPart{
  display:flex;
  gap:10px;
}

.rightPart img{
  width: 20px;
  height: 20px;
  object-fit: contain;
}
</style>
